var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackward(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_86_378)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.07372 4.8126C2.00187 4.91444 1.93681 5.0211 1.87902 5.13191C1.48344 5.89041 1.45634 6.78814 1.80546 7.56912L1.83752 7.64085C1.99359 7.98997 2.21577 8.30556 2.49181 8.57021L6.36875 12.2871C6.75426 12.6567 7.3185 12.7705 7.81715 12.5793L7.85828 12.5635C8.18427 12.4385 8.44481 12.1854 8.57925 11.8632C8.78228 11.3766 8.6652 10.8153 8.28459 10.4504L5.796 8.06449H13.5688V8.06351C14.7093 8.12199 15.8378 8.3631 16.9061 8.78249C18.7825 9.51912 20.3889 10.7727 21.5222 12.3846C22.6555 13.9965 23.2648 15.8944 23.273 17.8383C23.2812 19.7822 22.688 21.6848 21.5683 23.3055C20.4487 24.9262 18.8529 26.1921 16.9828 26.9433C15.1127 27.6945 13.0522 27.8971 11.062 27.5256C9.07173 27.1541 7.24109 26.2251 5.80155 24.8561C4.77871 23.8834 3.98596 22.7196 3.46794 21.444C3.11603 20.5774 2.23831 19.978 1.32026 20.1568C0.380607 20.3398 -0.237306 21.2631 0.0873391 22.1636C0.768185 24.0523 1.89297 25.7746 3.38408 27.1926C5.30564 29.02 7.74925 30.2601 10.4059 30.756C13.0626 31.2519 15.813 30.9814 18.3093 29.9787C20.8056 28.976 22.9357 27.2862 24.4303 25.1228C25.9248 22.9595 26.7167 20.4198 26.7057 17.825C26.6948 15.2302 25.8815 12.6968 24.3687 10.5451C22.8559 8.39344 20.7116 6.72017 18.2069 5.73688C16.4751 5.05702 14.6248 4.72813 12.771 4.76062C12.7501 4.7591 12.729 4.75832 12.7077 4.75832H5.63186L8.28459 2.21509C8.6652 1.8502 8.78228 1.28883 8.57925 0.802215C8.44481 0.480003 8.18427 0.22692 7.85828 0.101909L7.8269 0.089874C7.32467 -0.102723 6.75608 0.0200043 6.37801 0.402606L2.36996 4.45869C2.27723 4.55252 2.19138 4.65267 2.11299 4.75832H2.07372V4.8126Z",
    fill: "#FDFBF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44882 22.1667V20.7407H9.85415V17.3513H8.61415V16.256C8.98615 16.1802 9.30304 16.0941 9.56482 15.9977C9.8266 15.8943 10.0815 15.7669 10.3295 15.6153H11.6315V20.7407H12.8095V22.1667H8.44882ZM15.9512 22.2907C15.4139 22.2907 14.9489 22.2046 14.5562 22.0323C14.1704 21.8532 13.8432 21.6293 13.5746 21.3607L14.3599 20.2447C14.5597 20.4169 14.7698 20.565 14.9902 20.689C15.2176 20.8061 15.4483 20.8647 15.6826 20.8647C15.9926 20.8647 16.2302 20.7958 16.3956 20.658C16.5678 20.5202 16.6539 20.3067 16.6539 20.0173C16.6539 19.7349 16.5712 19.5248 16.4059 19.387C16.2406 19.2423 16.027 19.17 15.7652 19.17C15.593 19.17 15.4483 19.1907 15.3312 19.232C15.2141 19.2733 15.0557 19.356 14.8559 19.48L14.0912 18.984L14.2566 15.6153H18.1419V17.1033H15.7859L15.7032 18.054C15.8203 18.0127 15.9237 17.9851 16.0132 17.9713C16.1097 17.9576 16.213 17.9507 16.3232 17.9507C16.7021 17.9507 17.05 18.023 17.3669 18.1677C17.6907 18.3123 17.949 18.5362 18.1419 18.8393C18.3348 19.1356 18.4312 19.5144 18.4312 19.976C18.4312 20.4651 18.3176 20.8819 18.0902 21.2263C17.8629 21.5708 17.5598 21.836 17.1809 22.022C16.8089 22.2011 16.399 22.2907 15.9512 22.2907Z",
    fill: "#FDFBF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_86_378",
    x: 0,
    y: 0,
    width: 27.5058,
    height: 31.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_86_378"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_86_378",
    result: "effect2_innerShadow_86_378"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackward);
export default __webpack_public_path__ + "static/media/backward.c9f69fd9fe561101fa2da4e316d3483d.svg";
export { ForwardRef as ReactComponent };